import {
  URN_AUTH_INVALID_TOKEN,
  URN_AUTH_RATE_LIMITED,
  URN_QUOTA_BUDGET,
  URN_TOMTOM_UPSTREAM,
} from '@clearroute/shared'

/**
 * URN → user-visible error band (Plan 02-03 Task 3, D-83, T-2-PROB).
 *
 * Four discrete bands are surfaced to the user (UI-SPEC §Copywriting):
 *   - 'budget'   — TomTom daily free-tier budget hard-stop (D-43 + URN_QUOTA_BUDGET)
 *   - 'upstream' — TomTom 5xx bubbling through the proxy (URN_TOMTOM_UPSTREAM)
 *   - 'auth'     — any auth-class URN (invalid-token or rate-limited login)
 *   - 'unknown'  — anything else, including undefined URNs
 *
 * Decoupled from `apps/web/src/lib/api.ts` `classifyError(unknown)` so the
 * SearchDropdown error branch can work off the raw URN string without needing
 * an ApiError instance (e.g. when classifying an URN received from a cached
 * Problem body or a serialized error envelope).
 */

export type ErrorKind = 'budget' | 'upstream' | 'auth' | 'unknown'

export function classifyError(urn: string | undefined): ErrorKind {
  if (!urn) return 'unknown'
  if (urn === URN_QUOTA_BUDGET) return 'budget'
  if (urn === URN_TOMTOM_UPSTREAM) return 'upstream'
  if (urn === URN_AUTH_INVALID_TOKEN || urn === URN_AUTH_RATE_LIMITED) return 'auth'
  return 'unknown'
}
